module.exports = __webpack_public_path__ + "img/b02c89ec4b8e118e50d8bb44fa19f928.svg";